var _ = require('underscore');
var Backbone = require('backbone');

var CocreatorFormField = Backbone.Model.extend({

	idAttribute: 'id',
  pluralName:  'cocreatorFormFields',

  defaults: {
    'id': -1,
    'modelId': -1,
    'label': '',
    'cocreatorFormFieldAttributeData': {},
    'cocreatorVariableAttributes': undefined
  },

  getCocreatorVariableAttributeData: function getCocreatorVariableAttributeData() {
  	return this.get('cocreatorFormFieldAttributeData');
  },

  getCocreatorVariableAttributeIds: function getCocreatorVariableAttributeIds() {
    return _.pluck(this.getCocreatorVariableAttributeData(), 'id');
  }

});

module.exports = CocreatorFormField;